<template>
  <div class="scroll-births-and-hired">
    <div>
      <div v-if="loading" class="d-flex justify-center align-center h-64">
        <vue-element-loading :active="loading" spinner="mini-spinner" color="#004250"/>
      </div>
      <div v-show="!loading">
        <div v-for="item in filterLimitRow" :key="item.id">
          <div class="flex items-center px-3 py-3">
            <div class="recentTitle sm:1/4 xs:1/4 md:1/4 lg:1/6 xl:1/6 md:px-4 flex flex-col justify-center">
              <div class="text-zt-lg font-bold">{{ sliceDate(item.ddmm) }}</div>
              <div
                v-if="item.dateToShow && item.data.length > numberShow"
                class="mt-2"
              >
                <zt-button
                  class="text-zt-primary-200"
                  @click="(item.dateToShow = false) +(showMore(item.dateEs))"
                  color="primary"
                  outlined
                  icon="angle-down"
                  fab
                ></zt-button>
              </div>
              <div
                v-if="!item.dateToShow && item.data.length > numberShow"
                class="mt-2"
              >
                <zt-button
                  class="text-zt-primary-200"
                  @click="(item.dateToShow = true) + (showLess(item.dateEs))"
                  color="primary"
                  outlined
                  icon="angle-up"
                  fab
                ></zt-button>
              </div>
            </div>
            <div :id="item.dateEs" class="d-flex flex-wrap rowsDiv items-center">
              <div v-for="(element, index) in item.data"
                :key="index"
                class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 p-1 recentContainer">
                <zt-tooltip :text="`${element.nombre} ${element.apellido}`" color="primary">
                  <div
                    class="w-12 h-12 rounded-full flex items-center justify-center"
                    :class="element.foto_perfil != '' && element.foto_perfil.includes('/profileimage') ? '' : 'bg-white border border-solid border-primary text-zt-primary-200'"
                  >
                    <img
                      class="rounded-full"
                      v-if="element.foto_perfil != '' && element.foto_perfil.includes('/profileimage')"
                      :src="element.foto_perfil"
                    />
                    <div v-else>{{element.nombre.trim().charAt(0).toUpperCase() + element.apellido.trim().charAt(0).toUpperCase()}}</div>
                  </div>
                </zt-tooltip>
              </div>
            </div>
          </div>
          <hr />
        </div>
      </div>
      <div v-if="!loading" class="text-right">
        <button
          v-if="limitRow == 5 && Rows.length > 5"
          class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 py-4 font-normal text-gray-600 focus:outline-none mr-2"
          @click="limitRow = ''"
        >{{ $t('message.homeComponent.recentHired.show_more') }}</button>
        <button
          v-if="!limitRow && Rows.length > 5"
          class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 py-4 font-normal text-gray-600 focus:outline-none mr-2"
          @click="limitRow = 5"
        >{{ $t('message.homeComponent.recentHired.show_minus') }}</button>
      </div>
      <div
        v-if="!loading && !Rows.length"
        class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 p-1 py-10 text-center"
      >
        <div
          class="h-12 text-zt-dark-300 rowsDiv flex items-center justify-center font-normal"
        >{{ $t('message.homeComponent.recentHired.no_events') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '../../apiClient/User'
import moment from 'moment'
import { mapGetters } from 'vuex'
import _  from 'lodash'
import VueElementLoading from 'vue-element-loading';

export default {
  components: {
    VueElementLoading
  },
  props: {
    handlerFilter: Boolean,
    filterSector: String
  },
  data() {
    return {
      loading: true,
      Rows: [],
      fullData: [],
      filteredData: [],
      sectores: [],
      numberShow: 8,
      limitRow: 5,
      show:false,

    }
  },
  computed: {
    ...mapGetters(['getUser']),
    sliceDate() {
      return date => date.slice(0, -8)
    },
    filterLimitRow() {
      return this.limitRow ? this.Rows.slice(0, this.limitRow) : this.Rows
    }
  },
  created() {
    this.user = new User()
    this.getRecentHired()
    this.detectResolution()
  },
  methods: {
    detectResolution() {
      let resolution = window.screen.width;
      switch (true) {
        case (resolution < 500):
          this.numberShow = 6;
          break;
        case (resolution >= 501 && resolution <= 1023):
          this.numberShow = 9;
          break;
        case (resolution >= 1024 && resolution <= 1279):
          this.numberShow = 12;
          break;
        case (resolution >= 1280 && resolution <= 1439):
          this.numberShow = 14;
          break;
        case (resolution >= 1440 && resolution <= 1599):
          this.numberShow = 16;
          break;
        case (resolution >= 1600 && resolution <= 1919):
          this.numberShow = 21;
          break;
        case (resolution >= 1920 && resolution <= 2047):
          this.numberShow = 22;
          break;
        case (resolution >= 2048):
          this.numberShow = 23;
          break;
      }
    },
    async getRecentHired() {
      try {
        const { data } = await this.user.getRecentHired()
        this.fullData = data.results.data
        this.filteredData = data.results.data
        this.buildData(data.results.data)
        this.loading = false
      } catch (e) {
        this.loading = false
      }
    },
    buildData(data) {
      let resSectores = Array.from(data, x => x.sector);
      this.sectores = [...new Set(resSectores)];
      this.sectores.unshift('Ver todos');
      this.$store.dispatch('setHomeSectoresRecentHired', this.sectores);
      this.Rows = [];
      this.filteredData = this.fullData;
      if(this.filterSector != 'Ver todos') {
        this.filteredData = this.fullData.filter(item => item.sector === this.filterSector); 
      }
      const totalRow = _.uniqBy(this.filteredData, r => r.dm)
      for (let i = 0; i < totalRow.length; i++) {
        this.Rows.push({
          dateEn: `${totalRow[i].mes}${'/'}${totalRow[i].dia}${'/2020'}`,
          dateEs: `${totalRow[i].dia}${'/'}${totalRow[i].mes}`,
          ddmm: moment(`${totalRow[i].mes}${'-'}${totalRow[i].dia}${'-2020'}`, "MM-DD-YYYY")
            .locale('es')
            .format('LL'),
          data: this.filterData(`${totalRow[i].dia}${'/'}${totalRow[i].mes}`),
          dateToShow: true
        })
      }
    },
    filterData(date) {
      return this.filteredData.filter(result => result.dm === date)
    },
    showMore(id) {
      document.getElementById(id).classList.remove('rowsDiv')
    },
    showLess(id) {
      document.getElementById(id).classList.add('rowsDiv')
    }
  },
  watch: {
    filterSector: function() { 
      this.buildData(this.fullData);
    }
	}
}
</script>

<style lang="scss" scoped>
@import './public/assets/scss/_config.scss';

.recentTitle {
  min-width: 150px;
}

.recentContainer {
  max-width: 60px;
  font-size: $font-small;
}

.border-primary {
  border-color: $primary-color-200;
}

::v-deep .border-primary {
  border-color: $primary-color-200 !important;
}

::v-deep .text-zt-primary-200 {
    color: $primary-color-200 !important;
}

.rowsDiv {
  @media (min-width: 900px) {
    $line-height: 3;
    $font-size: 15px;
    $lines: 1;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 900px) {
    align-items: center;
    $lines: 8;
    $font-size: 14px;
    $line-height: 1;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>